module.exports = __webpack_public_path__ + "img/second_de.52b2660e.jpg";